/*
 * Copyright (c) 2024 Omnissa, Inc.
 * All Rights Reserved.
 */
import { Component, OnInit, NgZone } from '@angular/core';
import { AlertService } from '../services/alert.service';
import { ReportsService } from '../reports/reports.service';
import { Subscription } from 'rxjs/Subscription';
import { LimitsService } from '../limits/limits.service';
import { Array } from 'core-js/library/web/timers';
import { AuthService } from '../auth/authservice.service';
import { CategoriesRecord } from '../models/categoriesrecord';
import { ReportsComponent } from '../reports/reports.component';
import { PDFGenerator } from "../common/pdf/pdfgenerator";
import { NumberConstants } from "../common/numberconstants";
import { Globals } from 'app/common/globals';
import { TranslateService } from '@ngx-translate/core';
import { EnvironmentsService } from 'app/services/enviornment.service';
import { ActivatedRoute, Params } from '@angular/router';


@Component({
    styleUrls: ['./review.component.scss'],
    templateUrl: './review.component.html'
})
export class ReviewComponent implements OnInit {
    title: string = "Review Config Values & Publish";
    editModal: Boolean = false;
    rejectOpen: Boolean = false;
    commentsOpen: Boolean = false;
    comparisionHeaders: any;
    comparisions: any;
    publishInprogress: Boolean = false;
    loaded = true;
    modalProps = {
        state: false,
        backdrop: true,
        closable: false,
        title: "Reject Configuration",
        bodyContent: this.translateService.instant('admin.EnableRelMsg'),
        cancelButton: this.translateService.instant('cancel'),
        okButton: "Reject",
        cancelBClass: "btn-outline",
        okBClass: "btn-danger"
    };
    chatModalProps: any;
    private subscription: Subscription;
    selectedConfigset: any;
    exportDisabled = false;
    publishdate: any;
    lastUpdateDate: any;
    filename: any;
    rwversion: any;
    gadate: any;
    excludeInternal: any;
    publishedDisabled = true;
    langSub: Subscription;
    reviewPublish: String;
    publishType: number;
    count: number;
    isPublishByPage: boolean;

    //pagination
    p: number = this.numberconstants.ONE;
    totalRec: number;
    itemsPerPage = this.numberconstants.SIX;
    page = this.numberconstants.ONE;
    selectedAttribute: any;
    constructor(private alertService: AlertService, private zone: NgZone,
        private reportservice: ReportsService, private limitsService: LimitsService,private globals: Globals,private route: ActivatedRoute,
        private authservice: AuthService, private reportcomponent: ReportsComponent, private pdfGenerator: PDFGenerator,private numberconstants: NumberConstants, private translateService: TranslateService, private envService: EnvironmentsService) {
        this.initializeHeaders();
        this.initializeChatModal([]);
    }

    ngOnInit() {
        this.subscription = this.route.queryParams.subscribe((params: Params) => {
            if (params['vmwareproduct']) {
                this.reportservice.selectedBookmarkedprod = params["vmwareproduct"];
                this.reportservice.selectedBookmarkedversion = params["release"];
                this.reportservice.selectedBookmarkedCategories = params["categories"];
                }
                else{
                    this.reportservice.selectedBookmarkedprod = this.reportservice.selectedprodName;
                    this.reportservice.selectedBookmarkedversion = this.reportservice.selectedverName;
                    this.reportservice.selectedBookmarkedCategories = "";
                }
            });
        this.langSub = this.envService.selectedLanguage$.subscribe((lang)=>{
;            this.modalProps.bodyContent = this.translateService.instant('admin.EnableRelMsg');
            this.modalProps.cancelButton = this.translateService.instant('cancel');
            this.modalProps.title = this.translateService.instant('publishConfig');
            this.modalProps.bodyContent = this.translateService.instant('admin.EnableRelMsg');
            this.modalProps.okButton = this.translateService.instant('review.publish');
            this.modalProps.cancelButton = this.translateService.instant('cancel');
            this.translateService.instant('attrPublSuccess');
            this.translateService.instant('revertAlertLabel');
            this.translateService.instant('authorNotAssignedAlertLabel');
            this.translateService.instant('commentsUpdateAlertFailureLabel');
            this.comparisionHeaders[0].header = this.translateService.instant('manLimits.targetLimit');
            this.comparisionHeaders[1].header = this.translateService.instant('revPubl.gridHeadingTested');
            this.comparisionHeaders[2].header = this.translateService.instant('review.publish');
            this.comparisionHeaders[3].header = this.translateService.instant('review.keepInternal');
            this.comparisionHeaders[4].header = this.translateService.instant('limit.comment');
            this.reviewPublish = this.translateService.instant('subNav.review&Publish');

            this.subscription = this.reportservice.notifyObservable$.subscribe((res) => {
                this.initializeVariables();
                if (res.hasOwnProperty('option') && res.option === 'click') {
                    this.totalRec = this.numberconstants.ZERO;
                    this.loaded = false;
                    let categoriesData: CategoriesRecord = this.reportservice.getCategorieData(this.reportservice.selectedprodID,
                        this.reportservice.selectedversionID);
                    this.getCategoriesCount(categoriesData, true);
                    this.title = res.value;
                    this.exportDisabled = false;
                    this.publishedDisabled = false;
                }
                this.reportservice.onBookMark("/review/list", false, false, false);
            });
        });

    }


    getCategoriesCount(categoriesData: CategoriesRecord, showAll: boolean): number {
        let totalRec = this.numberconstants.ZERO;
        this.limitsService.getConfigMaximums(categoriesData,
            this.numberconstants.ZERO, this.numberconstants.ZERO, showAll, true)
            .subscribe(responseData => {
                if (responseData.ok === true) {
                    let releases = responseData.json();
                    totalRec = releases.length;
                    this.reportservice.totalRecords = totalRec;
                    this.getSubmaximums(this.reportservice.selectedprodID,
                        this.reportservice.selectedversionID);
                }
            },
                err => {
                    console.log(err);
                    totalRec = this.numberconstants.ZERO;
                    return this.numberconstants.ZERO;
                });
        return totalRec;
    }
    pageChanged(event) {
        this.p = event;
        this.page = event;
        this.loaded = false;
        this.comparisions = [];
        this.getSubmaximums(this.reportservice.selectedprodID,
            this.reportservice.selectedversionID);
    }

    getSubmaximums(prodId, versionId) {
        this.totalRec = this.reportservice.totalRecords;
        let categoriesData: CategoriesRecord = new CategoriesRecord();
        categoriesData.prodId = this.reportservice.selectedprodID;
        categoriesData.relId = this.reportservice.selectedversionID;
        categoriesData.categories = this.reportservice.categoriesArray;
        this.limitsService.getConfigMaximums(categoriesData,
            this.page, this.itemsPerPage, true, false)
            .subscribe(responseData => {
                let maxdata = responseData.json();
                if (responseData.ok === true) {
                    if (maxdata === undefined ||
                        maxdata.length === this.numberconstants.ZERO) {
                        maxdata = [];
                    }
                    this.count = maxdata.length;
                    maxdata.forEach(element => {
                        if (element.configs != undefined && element.configs.length > this.numberconstants.ZERO) {
                            element.configs.forEach(elementinner => {
                                if (elementinner.internal === "No") {
                                    elementinner.internal = false;
                                } else {
                                    elementinner.internal = true;
                                }
                            });
                        }
                    });
                    this.publishInprogress=false;
                    this.loaded = true;
                    this.comparisions = maxdata;
                }
            },
                err => {
                    console.log(err)
                    this.publishInprogress=false;
                    this.loaded = true;
                    this.comparisions = [];
                    this.totalRec = this.numberconstants.ZERO;
                    this.alertService.warn(this.translateService.instant('noMaximums'));
                    window.setTimeout(() => this.alertService.clear(), 5000);
                });
    }

    resetModal() {
        this.modalProps.title = "Reject Configuration";
        this.modalProps.bodyContent = this.translateService.instant('admin.EnableRelMsg');
        this.modalProps.okButton = "Reject";
        this.modalProps.cancelButton = this.translateService.instant('cancel');
        this.modalProps.cancelBClass = "btn-outline";
        this.modalProps.okBClass = "btn-danger";
    }

    launchModal(event) {
        let btnId = event.target.id;
        this.modalProps.title = this.translateService.instant('publishConfigMaxMsg');
        this.modalProps.bodyContent = this.translateService.instant('countMaximumMsg') + " " + "(" + this.count + this.translateService.instant('outOf') + " " + this.totalRec + " " + this.translateService.instant('configMaxMsg') + ")";
        this.modalProps.okButton = this.translateService.instant('confirm');
        this.modalProps.cancelButton = this.translateService.instant('cancel');
        this.modalProps.cancelBClass = "btn-outline";
        this.modalProps.okBClass = "btn-success";
        this.modalProps.state = true;
        this.publishType = 2;
        this.isPublishByPage = true;
    }
    launchPublishAllModal(event) {
        let btnId = event.target.id;
        this.modalProps.title = this.translateService.instant('publishConfigMaxMsg');
        this.modalProps.bodyContent = this.translateService.instant('publishAllMsg');
        this.modalProps.okButton = this.translateService.instant('confirm');
        this.modalProps.cancelButton = this.translateService.instant('cancel');
        this.modalProps.cancelBClass = "btn-outline";
        this.modalProps.okBClass = "btn-success";
        this.modalProps.state = true;
        this.publishType = 1;
        this.isPublishByPage = false;
    }
    publishAllModalHandler(btnOutput: boolean) {
        this.publishInprogress = true;
        if (btnOutput) {
            if (this.isPublishByPage === true) {
                let arr = [];
                let attrs = this.addattributes(3);
                this.limitsService.updateConfigAttributes(attrs,
                    this.reportservice.selectedprodID, this.reportservice.selectedversionID).subscribe(response => {
                        if (response && response.status === "OK") {
                            this.alertService.success(this.translateService.instant('attrPublSuccess'));
                            window.setTimeout(() => this.alertService.clear(), this.numberconstants.ALERT_DELAY_3000);
                            this.getSubmaximums(this.reportservice.selectedprodID,
                                this.reportservice.selectedversionID);
                        }
                    },
                        err => {
                            this.alertService.warn("Attributes could not be published");
                            window.setTimeout(() => this.alertService.clear(), this.numberconstants.ALERT_DELAY_3000);
                        });
            } 
            else {
                this.limitsService.updateAllConfigAttributes(this.reportservice.selectedprodID,
                    this.reportservice.selectedversionID, this.publishType, null, null).subscribe(response => {
                        if (response && response.status === "OK") {
                            this.alertService.success(this.translateService.instant('attrPublSuccess'));
                            window.setTimeout(() => this.alertService.clear(), this.numberconstants.ALERT_DELAY_3000);
                            this.getSubmaximums(this.reportservice.selectedprodID,
                                this.reportservice.selectedversionID);
                        }
                    },
                        err => {
                            this.publishInprogress = false;
                            this.alertService.warn("Attributes could not be published");
                            window.setTimeout(() => this.alertService.clear(), this.numberconstants.ALERT_DELAY_3000);
                            this.publishInprogress=false;
                        });
            }
        }
        else {
            this.publishInprogress=false;
        }
    }
    chatModalHandler(btnOutput: boolean) {
        if (btnOutput) {
            let currentUser = JSON.parse(localStorage.getItem('currentUser'));
            let authortype: number = this.numberconstants.ZERO;
            for (let i: number = this.numberconstants.ZERO; i < this.selectedAttribute.approvals.length; i++) {
                var found = this.selectedAttribute.approvals[i].authorName.indexOf("@");
                var authorname = currentUser.email;
                if (found == this.numberconstants.MINUS_ONE) {
                    var arr = currentUser.email.split('@');
                    authorname = arr[this.numberconstants.ZERO];
                }
                if (this.selectedAttribute.approvals[i].authorName === authorname) {
                    authortype = this.selectedAttribute.approvals[i].authorTypeId;
                    break;
                }
            }
            if (authortype > this.numberconstants.ZERO) {
                this.limitsService.updateAttrAuthors(this.selectedAttribute.id,
                    authortype, this.chatModalProps.selectedValue, authorname).subscribe(status => {
                        let statusObj: any = status;
                        if (statusObj.status === "OK") {
                            this.alertService.success(statusObj.message);
                            window.setTimeout(() => this.alertService.clear(), this.numberconstants.ALERT_DELAY_3000);
                        }
                    },
                        err => {
                            // Log errors if any
                            let errMsg: any = err.json();
                            this.alertService.warn(errMsg.message);
                            window.setTimeout(() => this.alertService.clear(), this.numberconstants.ALERT_DELAY_3000);
                        });
            } else {
                this.alertService.warn(this.translateService.instant('authorNotAssignedAlertLabel'));
                window.setTimeout(() => this.alertService.clear(), this.numberconstants.ALERT_DELAY_3000);
            }
        } else {
            this.alertService.warn(this.translateService.instant('commentsUpdateAlertFailureLabel'));
            window.setTimeout(() => this.alertService.clear(), this.numberconstants.ALERT_DELAY_3000);
        }
    }

    initializeHeaders(): void {
        this.comparisionHeaders = [
            {
                header: this.translateService.instant('manLimits.targetLimit'),
                class: "col-lg-3"
            },
            {
                header: this.translateService.instant('revPubl.gridHeadingTested'),
                class: "col-lg-3"
            },
            {
                header: this.translateService.instant('review.publish'),
                class: "col-lg-2"
            },
            {
                header: this.translateService.instant('review.keepInternal'),
                class: "col-lg-2"
            },
            {
                header: this.translateService.instant('limit.comment'),
                class: "col-lg-2"
            },
        ];
    }
    checkInternal(element) {
    }

    addattributes(statusId): any {
        let arr: any = [];
        this.comparisions.forEach(element => {
            if (element.configs != undefined && element.configs.length > this.numberconstants.ZERO) {
                element.configs.forEach(elementinner => {
                    if (statusId === this.numberconstants.APPROVEDSTATUS) {
                        elementinner.statusId = this.numberconstants.APPROVEDSTATUS;
                        elementinner.published = true;
                    } else {
                        elementinner.published = false;
                        elementinner.statusId = this.numberconstants.TWO;
                    }
                    if (elementinner.internal === true) {
                        elementinner.internal = "Yes";
                    } else {
                        elementinner.internal = "No";
                    }
                    elementinner.productId = this.reportservice.selectedprodID;
                    elementinner.versionId = this.reportservice.selectedversionID;
                    arr.push(elementinner);
                });
            }
        });
        return arr;
    }

    saveConfig(config) {
        this.editModal = false;
        let attrs = this.addattributes(this.numberconstants.ZERO);     
        this.limitsService.updateConfigAttributes(attrs,
            this.reportservice.selectedprodID, this.reportservice.selectedversionID).subscribe(response => {
                if (response && response.status === "OK") {
                    this.alertService.success("Attributes updated Successfully");
                    window.setTimeout(() => this.alertService.clear(), this.numberconstants.ALERT_DELAY_3000);
                    this.getSubmaximums(this.reportservice.selectedprodID,
                        this.reportservice.selectedversionID);
                }
            },
                err => {
                    this.alertService.warn("Attributes could not be updated");
                    window.setTimeout(() => this.alertService.clear(), this.numberconstants.ALERT_DELAY_3000);
                });
    }

    showChatModal(config: any): void {
        this.selectedAttribute = config;
        this.getAuthorComments(config.id.toString());
    }
    getAuthorComments(attrrId: String): void {
        let arr: any
        this.limitsService.getAttrAuthors(attrrId)
            .subscribe(authors => {
                if (authors === undefined || authors.length === this.numberconstants.ZERO) {
                    authors = [];
                }
                this.initializeChatModal(authors);
                this.chatModalProps.state = true
            },
                err => {
                    console.log(err)
                });
    }

    initializeChatModal(arr) {
        this.chatModalProps = {
            state: false,
            backdrop: true,
            hasCommentAccess: true,
            cancelButton: this.translateService.instant('cancel'),
            submitButton: this.translateService.instant('submit'),
            cancelBClass: "btn-outline",
            submitBClass: "btn-success",
            commentPlaceHolder: this.translateService.instant('revPubl.dataGridComment'),
            selectedValue: "",
            conversations: arr
        };
    }
    showComponentsAuthorized(resourceName): boolean {
        let hideComponent = true;
        if (this.reportservice.resorceactions === undefined ||
            this.reportservice.resorceactions.length === this.numberconstants.ZERO) {
            return true;
        }
        return hideComponent = this.authservice.checkaction(resourceName);
    }

    initlizedPdfMaxmium(): void {
        this.lastUpdateDate = this.reportservice.selectedConfigSet.lastUpdate;
        this.filename = this.reportservice.selectedverName;
        this.rwversion = this.reportcomponent.selectedVersion.rmVmwPrdRelVersion;
        this.gadate = this.reportcomponent.selectedVersion.rmVmwPrdRelGADate;
        this.exportDisabled = true;
    }

    exportToPDFwithInternal(): void {
        this.excludeInternal = "no"
        this.exportTOPDFLoggedIN();
    }

    exportToPDFwithoutInternal(): void {
        this.excludeInternal = "Yes";
        this.exportTOPDFLoggedIN();
    }

    exportTOPDFLoggedIN() {
        this.initlizedPdfMaxmium();
        this.exportDisabled = true;
        this.alertService.success(this.translateService.instant('revPubl.downloadMsg'));
        window.setTimeout(() => this.alertService.clear(), this.numberconstants.ALERT_DELAY_8000);
        let categoriesData: CategoriesRecord = new CategoriesRecord();
        categoriesData.prodId = this.reportservice.selectedprodID;
        categoriesData.relId = this.reportservice.selectedversionID;
        categoriesData.categories = this.reportservice.categoriesArray;
        this.limitsService.getConfigMaximums(categoriesData, this.numberconstants.ZERO, this.numberconstants.ZERO, true, false)
            .subscribe(responseData => {
                if (responseData.ok === true) {
                    let releases = responseData.json();
                    for (let release of releases) {
                        let maximumName = release.name;
                        let splitNames = maximumName.split(":")
                        release.names = splitNames;
                    }
                    this.pdfGenerator.pdfGenerate(releases, this.lastUpdateDate,
                        this.filename, this.rwversion, this.gadate, true, this.excludeInternal);
                    this.exportDisabled = false;
                }
            },
                err => {
                    console.log(err)
                    this.loaded = true;
                    this.totalRec = this.numberconstants.ZERO;
                    this.exportDisabled = false;
                    this.alertService.warn("No Maximums  is available for the SelectedVersion(" + this.filename + ") to export");
                    window.setTimeout(() => this.alertService.clear(), this.numberconstants.ALERT_DELAY_5000);
                });
    }

    checkIsEnabled() {
        return this.exportDisabled;
    }

    initializeVariables(): void {
        this.page = this.numberconstants.ONE;
        this.p = this.numberconstants.ONE;
        this.comparisions = [];
        this.totalRec = this.numberconstants.ZERO;
        this.reviewPublish = this.translateService.instant('subNav.review&Publish');
        this.exportDisabled = true;
        this.publishedDisabled = true;
    }

    publishEnabled(): boolean {
        return this.publishedDisabled;
    }

    showEditModal(): void {
        if (!this.publishedDisabled) {
            this.editModal = true;
        } else {
            this.editModal = false;
        }
    }

    ngOnDestroy() {
        this.langSub.unsubscribe();
    }
}



// WEBPACK FOOTER //
// ./src/app/review/review.component.ts